import { render, staticRenderFns } from "./activeChat.vue?vue&type=template&id=34f80122&scoped=true&"
import script from "./activeChat.vue?vue&type=script&lang=js&"
export * from "./activeChat.vue?vue&type=script&lang=js&"
import style0 from "./activeChat.vue?vue&type=style&index=0&lang=css&"
import style1 from "./activeChat.vue?vue&type=style&index=1&id=34f80122&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f80122",
  null
  
)

export default component.exports